import Button from 'components/button';
import useText from 'hooks/useText';
import { telHref } from 'pages/prospection/callListItems';

const EMPTY = '-';

// Stands for the call sheet (Prospection 3) until it is written: who is being
// called, and a way back to the waiting panel.
const CallSheetPlaceholder = ({ company, onClose }) => {
  const { text } = useText('prospection');
  const href = telHref(company?.phone);

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h2 className="ft-xl font-semibold text-gray-900">
          {company?.contactName || company?.name || EMPTY}
        </h2>
        <p className="ft-sm mt-1 text-gray-500">
          {company?.contactRole || EMPTY} · {company?.name || EMPTY} ·{' '}
          {href ? (
            <a href={href} className="text-yellow-500 hover:underline">
              {company.phone}
            </a>
          ) : (
            company?.phone || EMPTY
          )}
        </p>
      </div>
      <p className="ft-sm text-gray-500">{text('sheet.pending')}</p>
      <div className="flex justify-end">
        <Button color="SECONDARY" size="SM" onClick={onClose}>
          {text('sheet.close')}
        </Button>
      </div>
    </div>
  );
};

export default CallSheetPlaceholder;
